import React, { Component } from "react";

// import ListImgPdfButton from "../../../default/ListImgPdfButton";

function ListImgPdfButton(props) {
  return (
    <div className="sponsored-con-box">
      <div className="family-logo">
        <a className="family-link-site " href={props.site} target="_blank">
          {" "}
          <img src={props.src} alt={props.alt} />
        </a>
      </div>
      <div className="family-link">
        {props.alt == "코코다이브" || props.alt == "모비게임즈" ? (
          <a
            className="family-link-pdf "
            style={{ textIndent: "-9999px" }}
            target="_blank"
            rel="noopener noreferrer"
            type="application/pdf"
          >
            소개서 보기
          </a>
        ) : (
          <a
            className="family-link-pdf "
            // href={`https://docs.google.com/viewer?url=${encodeURIComponent(
            //   props.pdf
            // )}`}
            href={`https://docs.google.com/gview?embedded=true&url=https://maxthecreative-test.netlify.app${props.pdf}`}
            target="_blank"
            rel="noopener noreferrer"
            type="application/pdf"
          >
            소개서 보기
          </a>
        )}
      </div>
    </div>
  );
}

export default function Services() {
  return (
    <section className="section section-family services ">
      <h2 className="container">
        <span className="section-title sponsored-title color-dark ">
          Mobidays Services
        </span>
      </h2>
      <div className="section-con sponsored-con container">
        {SponsoredInfo.map((con, i) => {
          return (
            <ListImgPdfButton
              src={con.src}
              alt={con.alt}
              pdf={con.pdf}
              site={con.site}
              key={i}
            />
          );
        })}
      </div>
    </section>
  );
}

//DATA
const SponsoredInfo = [
  {
    src: process.env.PUBLIC_URL + "/images/ci/logo-max.png",
    alt: "맥스서밋",
    pdf: process.env.PUBLIC_URL + "/pdf/2026/MAX_SUMMIT_2025_KR.pdf",
    site: "https://maxsummit.co",
  },
  {
    src: process.env.PUBLIC_URL + "/images/ci/logo-inside.png",
    alt: "모비인사이드",
    pdf: process.env.PUBLIC_URL + "/pdf/2026/mobiinside_v1.4.pdf",
    site: "https://www.mobiinside.co.kr/",
  },
  {
    src: process.env.PUBLIC_URL + "/images/ci/logo-coko.png",
    alt: "코코다이브",
    pdf: process.env.PUBLIC_URL + "/pdf/2026/cokodive.pdf",
    site: "https://cokodive.com/",
  },
  {
    src: process.env.PUBLIC_URL + "/images/ci/logo-games.png",
    alt: "모비게임즈",
    pdf: process.env.PUBLIC_URL + "/pdf/2026/Mobigames.pdf",
    site: "https://www.mobigames.co.kr/",
  },
  {
    src: process.env.PUBLIC_URL + "/images/ci/logo-school.png",
    alt: "그로스쿨",
    pdf: process.env.PUBLIC_URL + "/pdf/2026/groschool.pdf",
    site: "https://groschool.kr/",
  },
  {
    src: process.env.PUBLIC_URL + "/images/ci/logo-ai.png",
    alt: "모비AI",
    pdf: process.env.PUBLIC_URL + "/pdf/2026/MOBIAI.pdf",
    site: "https://mobiai.co.kr/",
  },
  {
    src: process.env.PUBLIC_URL + "/images/ci/logo-connect.png",
    alt: "모비커넥트",
    pdf: process.env.PUBLIC_URL + "/pdf/mobiconnect.pdf",
    site: "http://www.mobiconnect.co.kr/",
  },
  {
    src: process.env.PUBLIC_URL + "/images/ci/logo-intouch.png",
    alt: "모비인터치",
    pdf: process.env.PUBLIC_URL + "/pdf/2026/mobintouch.pdf",
    site: "https://www.mobintouch.co.kr/",
  },
  {
    src: process.env.PUBLIC_URL + "/images/ci/logo-mobione.png",
    alt: "모비원",
    pdf: process.env.PUBLIC_URL + "/pdf/2023/MobiOne.pdf",
    site: "http://www.mobione.co/",
  },
];
